module.exports = __webpack_public_path__ + "img/saderat.f5418a80.png";